import React, { FC, useCallback, useMemo } from 'react';
import styles from './index.module.scss';
import { Button, Tooltip } from 'src/common';
import MemberList from 'src/common/MembersList';
import MpQuickActions from './MpQuickActions';
import { useLoadMp } from 'src/models/matchingProfiles/hooks';
import MonitoringProfileNotifications from 'src/shared/MatchingProfile/MatchingProfileNotifications';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { useOpenSidebar } from 'src/shared/InfoSidebar/hooks';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { trackMPEditMonitoringProfile } from 'src/segment/events';
import { ProcurementsDisplay } from 'src/models/procurements/types';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';

export const MpTitle: FC = () => {
  const { t } = useTranslation();
  const mp = useLoadMp();
  const currentMp = mp.data;

  const procurementTabInfo = useOverviewMode();

  const activeTab = useMemo((): string | undefined => {
    if (!procurementTabInfo) {
      return;
    }
    if (procurementTabInfo.tab === ProcurementsDisplay.MATCHED) {
      return procurementTabInfo.matchingId;
    }
    return procurementTabInfo.tab;
  }, [procurementTabInfo]);

  const openMpPreview = useOpenSidebar();

  const showDrawer = useCallback(() => {
    currentMp && openMpPreview({ id: currentMp.id, mode: SidebarMode.MP_INFO });
  }, [currentMp, openMpPreview]);

  const onOpenMpPreview = useCallback(() => {
    if (currentMp) {
      trackMPEditMonitoringProfile({ id: currentMp.id, name: currentMp.name });
    }

    openMpPreview({ id: activeTab || null, mode: SidebarMode.MP_INFO });
  }, [currentMp, openMpPreview, activeTab]);

  return (
    <>
      {currentMp && (
        <div className={styles.container}>
          <div className={styles.heading}>
            <div className={styles.title}>
              <Tooltip title={currentMp.name}>
                <span className={styles.titleName}>{currentMp.name}</span>
              </Tooltip>
            </div>
          </div>
          {
            <>
              <MonitoringProfileNotifications />
              <Button type={'text'} onClick={onOpenMpPreview} icon={<FontAwesomeIcon icon={faPen} />}>
                {t('Common.edit')}
              </Button>
              <MemberList
                owners={currentMp.owners}
                subscribersList={currentMp.subscribers}
                accessControlPolicy={currentMp.accessControl.subscribePolicy}
                onClick={showDrawer}
              />
              {!!currentMp?.accessToEdit && <MpQuickActions />}
            </>
          }
        </div>
      )}
    </>
  );
};

export default MpTitle;
